export default "__VITE_ASSET__ByDWjKca__"